import { Link } from "react-router-dom";
import { IconContext } from "react-icons";
import { MdOutlineCall } from "react-icons/md";
import { RiLinkedinFill } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";
import { IoLogoTwitter } from "react-icons/io";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { IoLogoInstagram } from "react-icons/io";

import logo from "../../assets/Vidom.png";
import styled from "styled-components";
import sendIcon from "../../assets/sendIcon.png";

import "../../styles/footer.css";

const FooterSection = styled.section`
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const StyledDiv = styled.div`
  padding-top: 1.5em;
  @media (min-width: 1024px) {
    flex: 1 1 0;
    width: 0px;
  }
`;

const Footer = (): JSX.Element => {
  return (
    <footer className="footer">
      <FooterSection className="footer-sect">
        <StyledDiv>
          <Link to="/">
            <img
              src={logo}
              alt="Vidom-logo"
              className="vidom-logo"
            />
          </Link>
          <p className="footer-content">
            Vidom makes investing in knowledge easy and seemless. Grow your
            skills today with Vidom to advance your career path.{" "}
          </p>

          <ul className="contact-icons-container">
            <IconContext.Provider value={{ className: "social-icons" }}>
              <li>
                <BsFacebook className="social-links" />
              </li>
              <li>
                <IoLogoInstagram className="custom-social-links" />
              </li>
              <li>
                <RiLinkedinFill className="custom-social-links" />
              </li>
              <li>
                <IoLogoTwitter className="custom-social-links" />
              </li>
            </IconContext.Provider>
          </ul>
        </StyledDiv>
        <StyledDiv className="footer-quick-links-cont">
          <h3>USEFUL LINKS</h3>
          <ul>
            <li>
              <Link to="/courses">Courses</Link>
            </li>
            <li>
              <Link to="plans">Plans</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/login">Login</Link>
            </li>
          </ul>
        </StyledDiv>
        <StyledDiv className="touch-links">
          <h3>GET IN TOUCH</h3>
          <ul>
            <li>
              <a href="mailto:hello@vidom.com">
                <span>@</span>hello@vidom.com
              </a>
            </li>
            <li>
              <a href="tel:+1678000000">
                <MdOutlineCall style={{ color: "var(--vidomCustomBlue)" }} />
                +1 (678) 000-0000
              </a>
            </li>
            <li>
              <div>
                <HiOutlineLocationMarker
                  style={{ color: "var(--vidomCustomBlue)" }}
                />
              </div>
              <div>
                <a href="https://maps.google.com">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Purus.
                </a>
              </div>
            </li>
          </ul>
        </StyledDiv>
        <StyledDiv>
          <h3>JOIN OUR MAILING LIST</h3>
          <p>Be The First To Know When A New Video Is Launched!</p>
          <div className="subscribers-container">
            <input
              type="email"
              placeholder="Enter your email address"
            />
            <div>
              <img
                src={sendIcon}
                alt="send"
                className="sendicon"
              />
            </div>
          </div>
        </StyledDiv>
      </FooterSection>
      <p className="copyright">Vidom ©2022</p>
    </footer>
  );
};

export default Footer;
